import { render, staticRenderFns } from "./distributorCoupon.vue?vue&type=template&id=3fe63f37&scoped=true"
import script from "./distributorCoupon.vue?vue&type=script&lang=js"
export * from "./distributorCoupon.vue?vue&type=script&lang=js"
import style0 from "./distributorCoupon.vue?vue&type=style&index=0&id=3fe63f37&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe63f37",
  null
  
)

export default component.exports